import { render } from "./inertie.vue?vue&type=template&id=270855b2&scoped=true&ts=true"
import script from "./inertie.vue?vue&type=script&lang=ts"
export * from "./inertie.vue?vue&type=script&lang=ts"

import "./inertie.vue?vue&type=style&index=0&id=270855b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270855b2"]])

export default __exports__